const conf = {
  appwriteUrl: process.env.REACT_APP_APPWRITE_URL,
  appwriteProjectId: process.env.REACT_APP_APPWRITE_PROJECT_ID,
  appwriteDatabaseId: process.env.REACT_APP_APPWRITE_DATABASE_ID,
  appwriteCollectionId: process.env.REACT_APP_APPWRITE_COLLECTION_ID,
  appwriteBucketId: process.env.REACT_APP_APPWRITE_BUCKET_ID,
  appwriteCollectionEventId: process.env.REACT_APP_APPWRITE_EVENT_COLLECTION_ID,
  appwriteCollectionDonationId: process.env.REACT_APP_APPWRITE_DONATION_COLLECTION_ID
};

export default conf;
